import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsProvider } from './settings-provider.service'
import { ConfigModel, EhsConfigModel, OpsMonthConfigModel, OpsProductionAreaModel, OpsProductionTypeModel, OpsWellsDrilledandConnectedModel, OpsExplorationAndDrillingMilestonesModel, FinSalesRevenueModel, FinSUpstreamUnitProductionCostModel, FinFreeCashFlowModel, FinGearingModel } from '../models/graphs.model';
import { AdalService } from '../authentication/adal.service'
import { WellsModel } from "../models/wells.model";
import { PermissionsModel } from "../models/permissions.model";

export interface FormResult {
	self: string;
	kind: object;
	contents: {
		success: boolean;
		returnMessage: string;
		ex: object;
	}
}


@Injectable()
export class GraphService {

	graphTestUrl: string = './assets/data/graphs.json';

	configUrl: string = '';
	wellsUrl: string = '';
	saveEhsConfigUrl: string = '';
	permissionsUrl: string = '';

	getOpsMonthUrl: string = '';
	saveOpsMonthUrl: string = '';
	saveOpsProductionAreaUrl: string = '';
	saveOpsProductionTypeUrl: string = "";
	saveOpsWellsDrilledandConnectedUrl: string = "";
	saveOpsExplorationAndDrillingMilestonesUrl: string = "";
	deleteOpsExplorationAndDrillingMilestonesUrl: string = "";

	savefinSalesRevenueUrl: string = "";
	savefinUpstreamUnitProductionCostModelUrl: string = "";
	saveFinFreeCashFlowModelUrl: string = "";
	saveFinGearingModelUrl:string = "";

	constructor(private http: HttpClient,
		private adalSvc: AdalService,
		private settingsProvider: SettingsProvider
	) {
		this.configUrl = settingsProvider.baseUrl + "Config/GetConfig";
		this.wellsUrl = settingsProvider.baseUrl + "Wells/GetWells";
		this.saveEhsConfigUrl = settingsProvider.baseUrl + "Config/SaveEhsConfig";
		this.permissionsUrl = settingsProvider.baseUrl + "Permissions/GetPermissions";

		this.getOpsMonthUrl = settingsProvider.baseUrl + "Operational/GetOpsMonth";
		this.saveOpsMonthUrl = settingsProvider.baseUrl + "Operational/SaveOpsMonth";
		this.saveOpsProductionAreaUrl = settingsProvider.baseUrl + "Operational/SaveOpsProductionArea";
		this.saveOpsProductionTypeUrl = settingsProvider.baseUrl + "Operational/SaveOpsProductionType";
		this.saveOpsWellsDrilledandConnectedUrl = settingsProvider.baseUrl + "Operational/SaveOpsWellsDrilledandConnected";
		this.saveOpsExplorationAndDrillingMilestonesUrl = settingsProvider.baseUrl + "Operational/SaveOpsExplorationAndDrillingMilestones";
		this.deleteOpsExplorationAndDrillingMilestonesUrl = settingsProvider.baseUrl + "Operational/DeleteOpsExplorationAndDrillingMilestones";

		this.savefinSalesRevenueUrl = settingsProvider.baseUrl + "Financial/SaveFinSalesRevenue";
		this.savefinUpstreamUnitProductionCostModelUrl = settingsProvider.baseUrl + "Financial/SaveFinUpstreamUnitProductionCost";
		this.saveFinFreeCashFlowModelUrl = settingsProvider.baseUrl + "Financial/SaveFinFreeCashFlow";
		this.saveFinGearingModelUrl = settingsProvider.baseUrl + "Financial/SaveFinGearing";
	}

	getConfig(): Observable<ConfigModel> {
		return this.adalSvc.get(this.configUrl);
	}

	getWells(): Observable<WellsModel> {
		return this.adalSvc.get(this.wellsUrl);
	}

	saveEhsConfig(ehsData: EhsConfigModel): Observable<FormResult> {
		return this.adalSvc.post(this.saveEhsConfigUrl, ehsData);
	}

	getPermissions(): Observable<PermissionsModel> {
		return this.adalSvc.get(this.permissionsUrl);
	}

	getOpsMonth(): Observable<OpsMonthConfigModel> {
		return this.adalSvc.get(this.getOpsMonthUrl);
	}

	postOpsMonth(opsMonthData: OpsMonthConfigModel): Observable<OpsMonthConfigModel> {
		return this.adalSvc.post(this.saveOpsMonthUrl, opsMonthData);
	}

	postOpsProductionArea(opsProdAreaData: OpsProductionAreaModel): Observable<OpsProductionAreaModel> {
		return this.adalSvc.post(this.saveOpsProductionAreaUrl, opsProdAreaData);
	}

	postOpsProductionType(opsProdTypeData: OpsProductionTypeModel): Observable<OpsProductionTypeModel> {
		return this.adalSvc.post(this.saveOpsProductionTypeUrl, opsProdTypeData);
	}

	postOpsWellsDrilledandConnected(opsWellsDrilledandConnectedData: any): Observable<any> {
		return this.adalSvc.post(this.saveOpsWellsDrilledandConnectedUrl, opsWellsDrilledandConnectedData);
	}

	postOpsExplorationAndDrillingMilestones(opsExplorationAndDrillingMilestonesData: any): Observable<any> {
		return this.adalSvc.post(this.saveOpsExplorationAndDrillingMilestonesUrl, opsExplorationAndDrillingMilestonesData);
	}

	deleteOpsExplorationAndDrillingMilestones(opsExplorationAndDrillingMilestonesData: OpsExplorationAndDrillingMilestonesModel): Observable<OpsExplorationAndDrillingMilestonesModel> {
		return this.adalSvc.post(this.deleteOpsExplorationAndDrillingMilestonesUrl, opsExplorationAndDrillingMilestonesData);
	}

	postFinSalesRevenue(finSalesRevenueData: FinSalesRevenueModel): Observable<FinSalesRevenueModel> {
		return this.adalSvc.post(this.savefinSalesRevenueUrl, finSalesRevenueData);
	}

	postFinUpstreamUnitProductionCost(finUpstreamUnitProductionCostData: FinSUpstreamUnitProductionCostModel): Observable<FinSUpstreamUnitProductionCostModel> {
		return this.adalSvc.post(this.savefinUpstreamUnitProductionCostModelUrl, finUpstreamUnitProductionCostData);
	}

	postFinFreeCashFlow(finFreeCashFlowData: FinFreeCashFlowModel): Observable<FinFreeCashFlowModel> {
		return this.adalSvc.post(this.saveFinFreeCashFlowModelUrl, finFreeCashFlowData);
	}

	postFinGearing(finGearingModelData: FinGearingModel): Observable<FinGearingModel> {
		return this.adalSvc.post(this.saveFinGearingModelUrl, finGearingModelData);
	}
}

